import React from 'react'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="gear" color="success" title="Software Backup">
        <EuiText>
          <p>
            Backup your camera settings to file.
          </p>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

